<script setup>
defineProps({
  loading: Boolean,
})
</script>

<template>
  <div
      :class="[
          loading ? 'tw-animate-pulse tw-bg-gray-100 tw-rounded-lg'
          : $attrs.class,
          ]"
  >
    <span class="tw-text-transparent" v-if="loading">{{ 'lorem' }}</span>
    <slot v-else ></slot>
  </div>
</template>